import NavigationDesktopMenu from './scripts/navigation-desktop-menu';

/**
 * @class NavigationDesktop
 * @classdesc Header navigation component is used to display menus on the header and set up their functionality
 *
 * @extends Core.Component
 */
export default class NavigationDesktop extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.navTier1 = el.querySelector('[data-nav-desktop-tier-1]');

    this.events.register(el, 'meganav:select', e => {
      if (!this.headerNavMenu) return;
      if (!Core.Breakpoints.min('M')) return;

      this.headerNavMenu.onBlockSelect(e.target);
    });
    this.events.register(el, 'meganav:deselect', () => {
      if (!this.headerNavMenu) return;

      this.headerNavMenu.onBlockDeselect();
    });
  }

  /**
   * On mount, we initialize the 1st level navigation menu
   */
  onMount() {
    if (this.navTier1) {
      this.headerNavMenu = new NavigationDesktopMenu({
        navList: this.navTier1,
      });
    }
  }
}
